module.exports = __webpack_public_path__ + "img/interest-4.380d31a2.png";